import { Component, Input, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { BlogType } from '@sifca-monorepo/ecommerce-generator';
import { catchError, of } from 'rxjs';
import { AppService } from '../../services/app.service';
import { SharedService } from '../../services';

@Component({
  template: '',
})
export class BaseBlogComponent implements AfterViewInit {
  @Input() loaded = false;

  posts: BlogType[];
  isLoading = true;
  @Input() blogLimit = 3;
  @Input() page = 0;
  posId: string = '';
  constructor(private appService: AppService, protected sharedService: SharedService, private changeDetectorRef: ChangeDetectorRef) {
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
    });
  }

  ngAfterViewInit() {
    this.appService
    .getBlogsByTargetPaginated(this.posId, this.page, this.blogLimit)
    .pipe(
      catchError(() => {
        return of(null);
      }),
    )
    .subscribe((res) => {
      if (res) {
        this.posts = res;
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  protected getNumberOfPosts(): number {
    return 0;
  }
}
